<template>
  <v-dialog
    v-model="dialog"
    width="700"
    @click:outside="dialog = !dialog"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="mr-2"
        v-bind="attrs"
        v-on="on"
      >
        Call Wrap up
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Call Wrap up</span>
      </v-card-title>
      <Loader v-if="loadingData" />
      <v-card-text v-else>
        <v-container fluid>
          <v-row align="center">
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
            >
              <v-select
                v-model="dispositionSelected"
                :items="dispositions"
                label="Dispositions"
                item-text="disposition"
                item-value="id"
                :rules="validations.dispositionSelected"
              />
            </v-col>

            <v-col
              class="d-flex"
              cols="12"
              sm="12"
            >
              <v-select
                v-model="reasonSelected"
                :items="reasons"
                label="Reason"
                item-text="reason"
                item-value="id"
                :rules="validations.reasonSelected"
              />
            </v-col>

            <v-col
              class="d-flex"
              cols="12"
              sm="12"
            >
              <v-textarea
                v-model="notes"
                label="Notes"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />

        <v-btn
          color="primary"
          class="mb-1"
          :loading="saving"
          :disabled="!ableToSave"
          @click="resolveTicket()"
        >
          Save
        </v-btn>

        <v-btn
          color="blue darken-1"
          text
          @click="dialog = !dialog"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import Loader from '@/components/ui/Loader.vue';

export default {
  name: 'TicketCallWrapUpModal',
  components: { Loader },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingData: false,
      saving: false,
      dispositionSelected: null,
      dispositions: [],
      reasonSelected: null,
      reasons: [],
      notes: null,
      dialog: false,
      validations: {
        dispositionSelected: [(value) => !!value || 'Please select a valid disposition'],
        reasonSelected: [(value) => !!value || 'Please select a valid reason'],
      },
    };
  },

  computed: {
    ableToSave() {
      return !!(this.dispositionSelected && this.reasonSelected);
    },
  },

  watch: {
    dialog(value) {
      if (value) {
        this.loadDispositionWithReasons();
      }
    },

    dispositionSelected(value) {
      this.updateReasons(value);
    },
  },

  methods: {
    ...mapActions('notification', ['setNotification']),

    updateReasons(disposition) {
      this.reasons = this.dispositions
        .find((currentDisposition) => currentDisposition.id === disposition)
        ?.dispositionReasons ?? [];
    },

    async loadDispositionWithReasons() {
      try {
        this.loadingData = true;

        const response = await this.$axios('api/v1/support/call-dispositions');

        if (response.status >= 200 && response.status < 300) {
          const { data } = response;
          this.dispositions = data.data ?? [];
        } else {
          this.setNotification({
            color: 'red',
            message: 'Error Loading Call Dispositions and Reasons',
          });
        }
      } catch (err) {
        console.info(err);
        // Show Notification
        this.setNotification({
          color: 'red',
          message: 'Error Loading Dispositions',
        });
      } finally {
        this.loadingData = false;
      }
    },

    resolveTicket() {
      this.saving = true;

      return this.$axios
        .post('api/v1/support/call-results', {
          zdTicketId: this.$route.params.id,
          callDispositionId: this.dispositionSelected,
          callDispositionReasonId: this.reasonSelected,
          notes: this.notes,
        })
        .then(() => {
          this.saving = false;
          this.$router.push({
            name: 'tickets',
          });
        })
        .catch((err) => {
          this.saving = false;
          console.info(err);
          const message = err.response?.data?.message ?? 'Ups, something went wrong!';

          this.setNotification({
            color: 'red',
            message,
          });
        });
    },
  },
};
</script>
